
import axios from 'axios';
import { serverConfig } from '../server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);

const ClientCandidateService = {
  search: async (query) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/candidate/semantic/search?query=${query.searchParams}&page=${query.page}&size=${query.size}`;
    return axios.get(url, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error in API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  getCandidateById: (clientId, candidateId) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-actions/get-candidate?clientId=${clientId}&candidateId=${candidateId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
  osSearch: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/candidate/os/for-client/search`;
    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error in OS Search API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  osInternalUserSearch: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/candidate/os/for-internal-user/search`;
    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error in OS Search API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

  osInternalUserSearch: async (body) => {
    const url = `https://${serverConfig.serverBaseAddress}/signite/candidate/os/for-internal-user/search`;
    return axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error("Error in OS Search API call:", error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('authToken');
          location.reload();
        }
        return Promise.reject(error);
      });
  },

};

export default ClientCandidateService;